import React from 'react';

const TeamOfTheMonth = () => {
  return <div>TeamOfTheMonth</div>;
};

export default TeamOfTheMonth;
